import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import i18next from "i18next";
import PopupWrapper from "../Common/PopupWrapper";
import confirm from "@mnjsplatform/components/lib/common/ConfirmFn";
import PlaceholderWrapper from "../Common/PlaceholderWrapper";

class UploadDocument extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {}
    }

    componentDidMount() {
        this.initialize();
    }

    initialize = async () => {
        try {
            await this.props.dispatch(this.props.dataItem.reset());
            await this.props.dispatch(this.props.dataItem_Prepare.execute({ClaimPDTypeId: this.props.row.ClaimPDTypeId}));
            if (!this.props.dataItem_Prepare.isError) {
                let rowKey = this.props.dataItem_Prepare.getRow(0);
                await this.props.dispatch(this.props.dataItem.execute(rowKey, {
                    withParams: true,
                    newItem: true
                }));
            } else {
                this.onCancel();
            }
        } catch {
            this.onCancel();
        }
    }
    onClose = () => {
        if (this.props.onClose)
            this.props.onClose();
    }
    onSave = async () => {
        try {
            await confirm(i18next.t('Upload_Document_1'));
            await this.props.dispatch(this.props.dataItem.save(0));
            if (!this.props.dataItem.isError) {
                this.onClose();
            }
        } catch {
        }
    }
    onCancel = () => {
        if (this.props.onClose)
            this.props.onClose();
    }
    renderButtons = () => {
        return (<div className="modal-footer text-right">
            <div className="text-right">
                <button className="btn btn-regular -goahead ml1ex" onClick={this.onSave}>{i18next.t('Send')}</button>
                <button className="btn btn-regular ml1ex" onClick={this.onCancel}>{i18next.t('Close')}</button>
            </div>
        </div>)
    }
    renderParam = (handler, isScan) => {
        return (<div className="row">
            <div className="col-md-12">
                {
                    handler.fs.map((fi) => {
                        const fn = fi.Name;
                        if (fi.fieldInfo.Name === "ScanCount" && !isScan)
                            return null;
                        return (<React.Fragment key={fn}>
                            <div className="row">
                                <div className="col-md-3 field-title text-md-right">
                                    {handler.lbl(fn)}
                                </div>
                                <div className="col-md-9">
                                    {handler.ed(fn)}
                                </div>
                            </div>
                            <hr/>
                        </React.Fragment>)
                    })
                }
            </div>
        </div>)
    }

    render() {
        if (!this.props.row)
            return null;

        return (
            <PopupWrapper popupVisible={true} title={this.props.row.ClaimPDTypeName} onClose={this.onClose}
                          showInstruction={false}
                          renderButtons={this.renderButtons} minHeightBody='200px' /*maxWidthBody='600px'*/>
                <PlaceholderWrapper placeholderId={`${this.props.row.ClaimPDTypeId}_CHANGE`} canCollapse={false}
                                    showSplitterLine={false}
                                    title={`${this.props.row.ClaimPDTypeName} - ${i18next.t("Change_1")}`} showHeaderTitle={false}>
                    <ComplexParam dataItem={this.props.dataItem}
                                  showApplyButton={false} showSearchBar={false} autoApplyParams={false}
                                  renderParams={(h) => this.renderParam(h, this.props.row.IsScan === 1)}
                                  fieldAttributes={{
                                      Comment: {max_chars: 300}
                                  }}/>
                </PlaceholderWrapper>
            </PopupWrapper>
        )
    }
}

UploadDocument.propTypes = {
    dispatch: PropTypes.func.isRequired,
    onClose: PropTypes.func,
    row: PropTypes.object,
    dataItem_Prepare: PropTypes.object,
    dataItem: PropTypes.object
}
UploadDocument.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        dataItem_Prepare: state.privateDocumentsState.Document_AddNew_Prepare,
        dataItem: state.privateDocumentsState.Document_Show
    }
}

export default connect(mapStateToProps)(UploadDocument)